<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label class="required">{{ $t('specification.product') }}</label>
						<a-select 
							v-model="model.pro_sale_code_id"
							class="ts-w-full"
							:options="salecodeList"
							showSearch
							:filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
						></a-select>
						<div class="validate" v-if="errors.has('pro_sale_code_id')">
							{{ errors.first('pro_sale_code_id') }}
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label class="required">{{ $t('specification.description') }}</label>
						<Vueditor
							v-bind:style="{ height: editor.height + 'px' }" 
						/>
						<div class="validate" v-if="errors.has('specification')">
							{{ errors.first('specification') }}
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
						<ts-button @click.prevent="$emit('cancel')">{{ $t('cancel') }}</ts-button>	
						<ts-button 
							v-if="!model.id"
							color="primary" outline
							:wating="waiting_new"
							@click.prevent="onSaveAddNew"
						>{{ $t('save_add_new') }}</ts-button>	
						<ts-button
							v-if="!model.id" 
							color="primary"
							:waiting="waiting"
							@click.prevent="onSave"
						>{{ $t('save') }}</ts-button>	
						<ts-button 
							v-if="model.id"
							color="primary"
							:waiting="waiting"
							@click.prevent="update"
						>{{ $t('update') }}</ts-button>	
				</div>	
			</div>	
		</ts-loading-banner>	
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
	name: 'specificationForm',
	data(){
		return {
			loading: false,
			waiting: false,
			waiting_new: false,
			errors: new Errors(),
			editor: {
				height: (window.innerHeight > 600) ? window.innerHeight - 315 : 300
			},
			model: {
				id: null,
				pro_sale_code_id: null,
				specification: null
			}
		}
	},
	created(){
		this.fetch()
		this.setEditData()
	},
	computed: {
		...mapState('product/specification', ['edit_data']),
		salecodeList(){
			return this.$store.state.product.specification.productSalecodes.map(el => ({
				value: el.pro_sale_code_id,
				label: el.name
			}))
		}
	},
	methods: {
		...mapActions('product/specification', ['fetResource']),
		fetch(){
			this.loading = true
			this.fetResource()
				.finally(() => {
					this.loading = false
				})
		},
		onSave(){
      this.errors = new Errors()
      this.waiting = true
			this.model.specification = this.$children[0].$children[1].getContent()
      this.$store
        .dispatch('product/specification/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
					this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.waiting = false
        })
		},
		onSaveAddNew(){
      this.errors = new Errors()
      this.waiting_new = true
			this.model.specification = this.$children[0].$children[1].getContent()
      this.$store
        .dispatch('product/specification/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
					this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.waiting_new = false
        })
		},
		update() {
      this.errors = new Errors()
      this.waiting = true
			this.model.specification = this.$children[0].$children[1].getContent()
      this.$store
        .dispatch('product/specification/update',{
            id: this.model.id,
            data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
					this.clearInput()
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.waiting = false
        })
    },
		setEditData(){
			if(!_.isEmpty(this.edit_data)){
				this.model.id = this.edit_data.id
				this.model.pro_sale_code_id = this.edit_data.pro_sale_code_id
				this.model.specification = this.edit_data.specification
				this.$nextTick(() => {
					this.$children[0].$children[1].setContent(this.edit_data.specification)
				})
			}
		},
		clearInput(){
			this.model.id = null
			this.model.pro_sale_code_id = null
			this.model.specification = null
			this.$children[0].$children[1].setContent('')
		}
	}
}
</script>